import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Modal,
  Select,
  Skeleton,
  Text,
  TextInput,
} from "@mantine/core";
import { Search } from "tabler-icons-react";
import flat from "flat";
import { showNotification } from "@mantine/notifications";
import { BeatLoader } from "react-spinners";
import colors from "../../utilities/design";
import AgreementListModal from "./AgreementListModal";
import { DatePicker } from "@mantine/dates";
import {
  getBussinessRegions,
  getBussinessUnit,
} from "../../utilities/apis/serviceProvider";
import { formatISO, parseISO } from "date-fns";
import {
  formatToIndianNumbering,
  loadingStates,
} from "../../utilities/utilities";

export const INDIA_STATES_UNIONS = [
  { label: "Andhra Pradesh", value: "Andhra Pradesh" },
  { label: "Karnataka", value: "Karnataka" },
  {
    label: "Andaman and Nicobar Islands",
    value: "Andaman and Nicobar Islands",
  },
  { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
  { label: "Assam", value: "Assam" },
  { label: "Bihar", value: "Bihar" },
  { label: "Chandigarh", value: "Chandigarh" },
  { label: "Chattisgarh", value: "Chattisgarh" },
  { label: "Dadra and Nagar Haveli", value: "Dadra and Nagar Haveli" },
  { label: "Daman and Diu", value: "Daman and Diu" },
  { label: "Delhi", value: "Delhi" },
  { label: "Goa", value: "Goa" },
  { label: "Gujarat", value: "Gujarat" },
  { label: "Haryana", value: "Haryana" },
  { label: "Himachal Pradesh", value: "Himachal Pradesh" },
  { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
  { label: "Jharkhand", value: "Jharkhand" },
  { label: "Kerala", value: "Kerala" },
  { label: "Lakshadweep Islands", value: "Lakshadweep Islands" },
  { label: "Madhya Pradesh", value: "Madhya Pradesh" },
  { label: "Maharashtra", value: "Maharashtra" },
  { label: "Manipur", value: "Manipur" },
  { label: "Meghalaya", value: "Meghalaya" },
  { label: "Mizoram", value: "Mizoram" },
  { label: "Nagaland", value: "Nagaland" },
  { label: "Odisha", value: "Odisha" },
  { label: "Pondicherry", value: "Pondicherry" },
  { label: "Punjab", value: "Punjab" },
  { label: "Rajasthan", value: "Rajasthan" },
  { label: "Sikkim", value: "Sikkim" },
  { label: "Tamil Nadu", value: "Tamil Nadu" },
  { label: "Telangana", value: "Telangana" },
  { label: "Tripura", value: "Tripura" },
  { label: "Uttar Pradesh", value: "Uttar Pradesh" },
  { label: "Uttarakhand", value: "Uttarakhand" },
  { label: "West Bengal", value: "West Bengal" },
];

const LegacyAgreementForm1 = ({
  setLegacyAgreementFormValue,
  legacyAgreementFormValue,
  uiConfigs,
  setUiConfigs,
  saveAgreement,
}) => {
  const typeOfDocuments = [
    "Parent",
    "Supplementary",
    "Supplementary to Supplementary",
  ];
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLegacyAgreementFormValue({
      ...legacyAgreementFormValue,
      requestingUser: {
        ...legacyAgreementFormValue.requestingUser,
        [name]: value,
      },
    });
  };

  const [businessUnitsOptions, setBusinessUnitsOptions] = useState([]);
  const [businessRegionOptions, setBusinessRegionOptions] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [title, setTitle] = useState("");

  // Debounce effect to add typed value after 500ms of no typing
  useEffect(() => {
    const timeout = setTimeout(() => {
      const trimmed = searchValue.trim();
      const exists =
        legacyAgreementFormValue.typeOfAgreementData.includes(trimmed);
      if (trimmed && !exists) {
        setLegacyAgreementFormValue((prev) => ({
          ...prev,
          typeOfAgreementData: [...prev.typeOfAgreementData, trimmed],
          typeOfAgreement: trimmed,
        }));
      }
    }, 500);

    return () => clearTimeout(timeout); // Clear on next keystroke
  }, [searchValue]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      const trimmed = title.trim();
      const exists =
        legacyAgreementFormValue.titleOfAgreementData.includes(trimmed);
      if (trimmed && !exists) {
        setLegacyAgreementFormValue((prev) => ({
          ...prev,
          titleOfAgreementData: [...prev.titleOfAgreementData, trimmed],
          titleOfAgreement: trimmed,
        }));
      }
    }, 500);

    return () => clearTimeout(timeout); // Clear on next keystroke
  }, [title]);
  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const { data } = await getBussinessUnit();

        if (data) {
          setBusinessUnitsOptions(
            data.businessunitList.map((unit) => ({
              value: unit.id + "",
              label: unit.name,
            })) || [],
          );
        } else {
          console.error("Invalid business unit response format:", data);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };
    const fetchRegions = async () => {
      try {
        const { data } = await getBussinessRegions();
        if (data) {
          setBusinessRegionOptions(
            data.businessRegionList.map((unit) => ({
              value: unit.id + "",
              label: unit.name,
            })) || [],
          );
        }
      } catch {
        console.log("error fetching business regions");
      }
    };
    fetchRegions();
    fetchBusinessUnits();
  }, []);
  const reminderLabels = {
    15: "15 days",
    30: "30 days",
    45: "45 days",
    60: "60 days",
  };
  const saveNext = async () => {
    const keys = {};
    if (
      !legacyAgreementFormValue?.relationshipType ||
      legacyAgreementFormValue?.relationshipType?.length < 3
    ) {
      keys.typeOfDocument = "Contract type is mandatory.";
    }

    if (
      !legacyAgreementFormValue?.typeOfAgreement ||
      legacyAgreementFormValue?.typeOfAgreement?.length < 3
    ) {
      keys.typeOfAgreement = "Type is mandatory.";
    }
    if (
      !legacyAgreementFormValue?.titleOfAgreement ||
      legacyAgreementFormValue?.titleOfAgreement?.length < 3
    ) {
      keys.titleOfAgreement = "Title is mandatory.";
    }
    if (
      !legacyAgreementFormValue?.titleOfAgreement ||
      legacyAgreementFormValue?.titleOfAgreement?.length > 50
    ) {
      keys.titleOfAgreement =
        "The title for the agreement should stay within 50 characters or less.";
    }
    if (
      !legacyAgreementFormValue.dateOfContract ||
      isNaN(parseISO(legacyAgreementFormValue.dateOfContract).getTime())
    ) {
      keys["dateOfContract"] = "Please enter date.";
    }

    if (!legacyAgreementFormValue.businessUnit) {
      keys["businessUnit"] = "Please enter Business Unit.";
    }

    if (
      !legacyAgreementFormValue.dueDateOfContract &&
      (!legacyAgreementFormValue.noOfYears ||
        isNaN(legacyAgreementFormValue.noOfYears) ||
        parseInt(legacyAgreementFormValue.noOfYears, 10) <= 0) &&
      (!legacyAgreementFormValue.noOfMonths ||
        isNaN(legacyAgreementFormValue.noOfMonths) ||
        parseInt(legacyAgreementFormValue.noOfMonths, 10) <= 0)
    ) {
      keys["noOfYears"] = "Please check value.";
      keys["noOfMonths"] = "Please check value.";
      keys["dueDateOfContract"] = "please check value";
    }
    // if (legacyAgreementFormValue?.requestingUser?.phone?.length > 0) {
    //   if (
    //     !validateMobile(legacyAgreementFormValue?.requestingUser?.phone) ||
    //     legacyAgreementFormValue?.requestingUser?.phone.length !== 10
    //   ) {
    //     keys["requestingUser.phone"] = "Please enter 10 digits phone number.";
    //   }
    // } else {
    //   keys["requestingUser.phone"] = "Please enter 10 digits phone number.";
    // }
    console.log("Validation errors:", keys);
    if (Object.keys(keys).length > 0) {
      form.setErrors(keys);
      showNotification({
        color: "red",
        title: "Agreement Form",
        message: "Please check all fields are filled properly.",
      });
    } else {
      await saveAgreement();
      setUiConfigs({
        ...uiConfigs,
        currentStep: 1,
      });
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState(0);
  const handleSearchClick = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (selectedAgreement) {
      setLegacyAgreementFormValue({
        ...legacyAgreementFormValue,
        relationshipWith: selectedAgreement + "",
      });
    }
  }, [selectedAgreement]);

  const handleChange = (e) => {
    const inputValue = e.target.value.replace(/,/g, ""); // Remove commas
    const numericValue = parseInt(inputValue, 10); // Convert to integer

    if (!isNaN(numericValue)) {
      setLegacyAgreementFormValue({
        ...legacyAgreementFormValue,
        agreementValue: numericValue,
      });
    } else {
      setLegacyAgreementFormValue({
        ...legacyAgreementFormValue,
        agreementValue: 0,
      });
    }
  };

  console.log("agreementFormValues", legacyAgreementFormValue);
  return (
    <>
      {showModal && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <AgreementListModal
            onCloseAgreement={handleCloseModal}
            setSelectedAgreement={setSelectedAgreement}
          />
        </Modal>
      )}
      <div className="w-full flex flex-col my-4">
        <div className="grid grid-cols-2">
          <div>
            <TextInput
              className="max-w-lg"
              label="job order"
              placeholder="enter job order"
              onChange={(e) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  jobOrder: e.target.value,
                });
              }}
              value={legacyAgreementFormValue.jobOrder}
              style={{ maxWidth: "82%" }}
            />
          </div>
          <div></div>
          <div className="">
            <Select
              required
              className="max-w-lg"
              label="contract type"
              placeholder="select contract type"
              data={typeOfDocuments.map((value) => ({ value, label: value }))}
              onChange={(selectedOption) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  relationshipType: selectedOption,
                });
              }}
              value={legacyAgreementFormValue.relationshipType}
              style={{ maxWidth: "82%" }}
            />
          </div>
          <div style={{ maxWidth: "82%" }} className="flex">
            <TextInput
              label="connected agreement"
              placeholder="enter agreement number"
              required={
                legacyAgreementFormValue.relationshipType === "Supplementary" ||
                legacyAgreementFormValue.relationshipType ===
                  "Supplementary to Supplementary"
              }
              onChange={(e) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  relationshipWith: e.target.value,
                });
              }}
              value={legacyAgreementFormValue.relationshipWith || ""}
              type="number"
              style={{
                width: "88%",
                display: "inline-block",
                marginRight: "2%",
              }}
            />
            <Button
              className="max-w-lg"
              color="#2196F3"
              onClick={handleSearchClick} // Call the handler on button click
              style={{
                width: "10%",
                display: "inline-block",
                marginBottom: "0",
                marginTop: "auto",
                padding: "0",
                backgroundColor: "#1b6f8d",
              }}
            >
              <Search size={20} strokeWidth={3} />
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-2 ">
          <Select
            searchable
            required
            creatable
            className="max-w-lg"
            style={{ maxWidth: "82%" }}
            label="contract category"
            placeholder="select contract category"
            data={legacyAgreementFormValue.typeOfAgreementData}
            getCreateLabel={(query) => `+ add ${query}`}
            onCreate={(query) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                typeOfAgreementData: [
                  ...legacyAgreementFormValue.typeOfAgreementData,
                  query,
                ],
                typeOfAgreement: query,
              });
            }}
            onChange={(selectedOption) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                typeOfAgreement: selectedOption,
              });
            }}
            onSearchChange={(value) => {
              setSearchValue(value);
            }}
            value={legacyAgreementFormValue.typeOfAgreement || null}
          />
          <Select
            searchable
            required
            creatable
            className="max-w-lg"
            label="contract title"
            placeholder="select contract title"
            style={{ maxWidth: "82%" }}
            data={legacyAgreementFormValue.titleOfAgreementData}
            getCreateLabel={(query) => `+ add ${query}`}
            onCreate={(query) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                titleOfAgreementData: [
                  ...legacyAgreementFormValue.titleOfAgreementData,
                  query,
                ],
                titleOfAgreement: query,
              });
            }}
            onSearchChange={(val) => setTitle(val)}
            onChange={(selectedOption) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                titleOfAgreement: selectedOption,
              });
            }}
            value={legacyAgreementFormValue.titleOfAgreement || null}
          />
        </div>
        <Divider className="mt-3" />
        <Text size="md" color="#1b6f8d" className="my-3">
          term & location
        </Text>
        <div className="grid grid-cols-2 ">
          <DatePicker
            required
            style={{ marginBottom: "10px", maxWidth: "82%" }}
            label="starting date"
            placeholder="select starting date"
            onChange={(val) => {
              if (val && val.getTime) {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  dateOfContract: formatISO(val),
                });
              } else {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  dateOfContract: null,
                });
              }
            }}
            value={
              legacyAgreementFormValue.dateOfContract
                ? parseISO(legacyAgreementFormValue.dateOfContract)
                : null
            }
          />

          {!legacyAgreementFormValue.dueDateOfContract && (
            <div
              className="flex flex-row"
              style={{ marginBottom: "10px", maxWidth: "82%" }}
            >
              <Select
                required
                label="duration"
                placeholder="select years"
                data={[
                  ...Array.from({ length: 11 }, (_, i) => ({
                    value: `${i}`,
                    label: `${i} year${i === 1 ? "" : "s"}`,
                  })),
                  { value: "100", label: "100 years" }, // Add the option for 100 years
                ]}
                onChange={(selectedOption) => {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    noOfYears: selectedOption,
                  });
                }}
                value={legacyAgreementFormValue.noOfYears}
                style={{ width: "120px", marginRight: "20px" }}
              />
              <Select
                label="   "
                placeholder="select months"
                data={[
                  { value: "0", label: "0 month" },
                  ...Array.from({ length: 12 }, (_, i) => ({
                    value: `${i + 1}`,
                    label: `${i + 1} month${i === 0 || i === 1 ? "" : "s"}`,
                  })),
                ]}
                onChange={(selectedOption) => {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    noOfMonths: selectedOption,
                  });
                }}
                value={legacyAgreementFormValue.noOfMonths}
                style={{ width: "120px", marginRight: "20px" }}
              />
              <Select
                label="   "
                placeholder="select days"
                data={[
                  { value: "0", label: "0 day" },
                  ...Array.from({ length: 30 }, (_, i) => ({
                    value: `${i + 1}`,
                    label: `${i + 1} day${i === 0 || i === 1 ? "" : "s"}`,
                  })),
                ]}
                onChange={(selectedOption) => {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    noOfDays: selectedOption,
                  });
                }}
                value={legacyAgreementFormValue.noOfDays}
                style={{ width: "120px" }}
              />
            </div>
          )}
          {!legacyAgreementFormValue.noOfMonths &&
            !legacyAgreementFormValue.noOfYears &&
            !legacyAgreementFormValue.noOfDays && (
              <DatePicker
                style={{ marginBottom: "10px", maxWidth: "82%" }}
                label="end date"
                placeholder="select end date"
                onChange={(val) => {
                  if (val && val.getTime) {
                    setLegacyAgreementFormValue({
                      ...legacyAgreementFormValue,
                      dueDateOfContract: formatISO(val),
                    });
                  } else {
                    setLegacyAgreementFormValue({
                      ...legacyAgreementFormValue,
                      dueDateOfContract: null,
                    });
                  }
                }}
                value={
                  legacyAgreementFormValue.dueDateOfContract
                    ? parseISO(legacyAgreementFormValue.dueDateOfContract)
                    : null
                }
              />
            )}
          <TextInput
            style={{ width: "80%" }}
            value={
              formatToIndianNumbering(
                legacyAgreementFormValue.agreementValue || 0,
              ) || ""
            }
            label="annual agreement value (₹)"
            placeholder="annual agreement value"
            onChange={handleChange}
          />
          <Select
            style={{ marginBottom: "10px", maxWidth: "82%" }}
            placeholder="reminder time"
            label="renewal reminder time (in days)"
            data={[
              { value: "15", label: "15 days" },
              { value: "30", label: "30 days" },
              { value: "45", label: "45 days" },
              { value: "60", label: "60 days" },
            ]}
            onChange={(val) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                reminderTimeInDays: val,
              });
            }}
            value={legacyAgreementFormValue.reminderTimeInDays || null}
          />
          <Select
            style={{ marginBottom: "10px", maxWidth: "82%" }}
            searchable
            placeholder="enter location"
            label="location"
            data={[...INDIA_STATES_UNIONS]}
            onChange={(val) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                location: val,
              });
            }}
            value={legacyAgreementFormValue.location || null}
          />
          <Select
            required
            searchable
            placeholder="enter business unit"
            label="business unit"
            data={businessUnitsOptions}
            onChange={(val) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                businessUnit: val,
              });
            }}
            value={legacyAgreementFormValue.businessUnit || null}
            dropdownPosition="bottom"
            style={{ maxWidth: "82%" }}
          />
          <Select
            required
            searchable
            placeholder="select business region"
            label="business region"
            data={businessRegionOptions}
            onChange={(val) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                mapRegion: val,
              });
            }}
            value={legacyAgreementFormValue.mapRegion || null}
            dropdownPosition="bottom"
            style={{ maxWidth: "82%" }}
          />
          {/* <TextInput required label="Location" placeholder='Enter location' {...legacyAgreementFormValue.getInputProps('location')}/> */}
        </div>
      </div>
      <div className="flex flex-row justify-between">
        <div></div>
        <Button
          className="max-w-xs right mt-2"
          style={{
            backgroundColor: "#1b6f8d",
          }}
          onClick={saveNext}
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default LegacyAgreementForm1;
